import { NetworkStatusEnum } from './types';
export default class NetworkStatus {
  constructor(networkChangeCallback) {
    this._networkChangeCallback = networkChangeCallback;
    if (typeof window !== 'undefined') {
      window.addEventListener('offline', () => this._networkChangeCallback(NetworkStatusEnum.OFFLINE));
      window.addEventListener('online', () => this._networkChangeCallback(NetworkStatusEnum.ONLINE));
    }
  }
  removeListeners() {
    if (typeof window !== 'undefined') {
      window.addEventListener('offline', () => this._networkChangeCallback(NetworkStatusEnum.OFFLINE));
      window.addEventListener('online', () => this._networkChangeCallback(NetworkStatusEnum.ONLINE));
    }
  }
  getNetworkStatus() {
    if (window.navigator.onLine) {
      return NetworkStatusEnum.ONLINE;
    }
    return NetworkStatusEnum.OFFLINE;
  }
}